
import * as React from "react"
import PropTypes from "prop-types"
import "../scss/site.scss"  
import Scrolling from "../components/scrolling"
import Overlay from "../components/overlay"
import Footer from "../components/footer"

const Layout = ({ children, className ,footerClassName}) => {
  return (
    <>
      <a href="#main-content" className="skip-link">Skip to main content</a>
      <main id="main-content" tabIndex={-1} className={className}>
        {children}
        <Overlay />
        <Scrolling />
      </main>
      <Footer footerClassName={footerClassName} />
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
